export const LOGGED_IN_USER = "LOGGED_IN_USER";
export const LOGGED_OUT = "LOGGED_OUT";
